import { render, staticRenderFns } from "./ThumbhashImage.vue?vue&type=template&id=3bc9889f&"
import script from "./ThumbhashImage.vue?vue&type=script&lang=js&"
export * from "./ThumbhashImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports